export default {
  loggedIn: {
    deposit: 'Magdeposito',
    withdraw: 'Mag-withdraw',
    balance: 'Kabuuang Balanse',
    cash: 'Cash',
    bonus: 'Bonus',
    withdrawable: 'Withdrawable',
    transaction: 'Transaksyon',
    history: 'Kasaysayan',
    myBet: 'My Bet',
    rollover: 'Rollover',
    vault: 'Kabaong',
    notification: 'Abiso',
    affiliate: 'Affiliate - Kumita ng $5,000 Bawat Buwan',
    affiliateTitle: 'Affiliate',
    affiliateBadge: 'Kumita ng $5,000 Bawat Buwan',
    settings: 'Mga Setting',
    currency: 'Pera',
    language: 'Wika',
    liveSupport: 'Live na Suporta',
    signOut: 'Mag-sign out'
  }
};
